<template>
  <Container
    tag="header"
    class="flex h-full min-h-[45svh] px-container pb-28 pt-32 sm:px-container-lg"
  >
    <AnimatedContainer
      class="w-full max-w-container flex-col justify-center sm:flex"
      :class="parentUrl ? 'sm:pt-24' : 'pt-[2.875rem] sm:pt-[8.25rem]'"
    >
      <AppLink
        v-if="parentUrl && parentUrl !== '/'"
        :to="localePath(parentUrl)"
        :show-link-arrow="true"
        :arrow-left="true"
        class="slide-up mb-2 ml-2 w-fit py-2 pr-2 capitalize typo-button-md"
      >
        {{ $t('back') }}
      </AppLink>

      <!-- TITLE -->
      <TextAppear
        v-if="data.heading"
        tag="h1"
        class="slide-up typo-heading-xl md:typo-heading-2xl xl:typo-heading-3xl"
        :text="data.heading"
      />

      <div class="ml-auto mt-24 sm:mt-36">
        <!-- SUBTITLE -->
        <h2
          v-if="data.sub_heading"
          class="slide-right mb-4 max-w-120 typo-heading-2xs md:typo-heading-xs"
        >
          {{ data.sub_heading }}
        </h2>

        <!-- TEXT -->
        <div
          v-if="data.text"
          class="default-text-styles slide-right max-w-180 text-gray-300 typo-body-sm md:typo-body-md"
          v-html="data.text"
        />
      </div>
    </AnimatedContainer>
  </Container>
</template>

<script setup lang="ts">
import type { ReplicatorHerosHeroDefaultFragment } from '#gql'

const entry = inject(EntryInjectionKey)!

const localePath = useLocalePath()
const router = useRouter()

const parentUrl = computed(() => {
  if (entry.value?.blueprint !== 'page') {
    return `/${router.currentRoute.value?.params.uri[0]}`
  }

  if (entry.value?.parent?.published) {
    return entry.value?.parent?.url
  }

  return null
})

defineProps<{
  data: Enforce<ReplicatorHerosHeroDefaultFragment>
}>()
</script>
